import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Github, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">
              Kesho<span className="text-orange-600">Studio</span>
            </h3>
            <p className="text-sm text-slate-400 mb-4">
              Building the future of Web3 in Africa. A crypto venture builder and investor accelerating blockchain innovation across the continent.
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-orange-600 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="hover:text-orange-600 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="hover:text-orange-600 transition-colors">
                <Github size={20} />
              </a>
              <a href="mailto:hello@keshostudio.com" className="hover:text-orange-600 transition-colors">
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-orange-600 transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-orange-600 transition-colors">About</Link></li>
              <li><Link to="/portfolio" className="hover:text-orange-600 transition-colors">Portfolio</Link></li>
              <li><Link to="/team" className="hover:text-orange-600 transition-colors">Team</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:hello@keshostudio.com" className="hover:text-orange-600 transition-colors">
                  hello@keshostudio.com
                </a>
              </li>
              <li className="text-slate-400">Pan-African (Remote-First)</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 text-center text-sm text-slate-400">
          <p>&copy; {new Date().getFullYear()} Kesho Studio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
